import React, {useState} from 'react';
import '../../styles/style.css';
import list from "../../assets/images/list.png";
import axios from "axios";
import Base from "../../config";

const List_With_Us = ({ resorts }) => {
  const [villa, SetVilla] = useState("");
  const [name, SetName] = useState("");
  const [email, SetEmail] = useState("");
  const [contact, SetContact] = useState("");
  const [location, SetLocation] = useState("");
  const [message, SetMessage] = useState("");
  const [checkbox, setCheckbox] = useState("");

  const [errors,setErrors] = useState("");
  const HandleVillaChange = (event)=>{
    SetVilla(event.target.value);
    setErrors('');
    SetEmailMessage('');
  }

  const HandleNameChange = (event)=>{
    SetName(event.target.value);
    setErrors('');
    SetEmailMessage('');

  }

  const HandleEmailChange = (event)=>{
    SetEmail(event.target.value);
    setErrors('');
    SetEmailMessage('');
  }

  const HandleContactChange = (event)=>{
    SetContact(event.target.value);
    setErrors('');
    SetEmailMessage('');

  }

  const HandleLocationChange = (event)=>{
    SetLocation(event.target.value);
    setErrors('');
    SetEmailMessage('');
  }

  const HandleMessageChange = (event)=>{
    SetMessage(event.target.value);
    setErrors('');
    SetEmailMessage('');
  }
  const handleCheckboxChange = (event) =>{
    setCheckbox(event.target.value);
  }

  const [loading, setLoading] = useState(false);
  const [emailMessage,SetEmailMessage] = useState("");


  const List_with_us_form = (e) =>{
    e.preventDefault();

    setLoading(true);

    const List_form_data = {
      villa,
      name,
      email,
      contact,
      location,
      message,
      checkbox
    }

    axios.post(Base.BASE_API_URL+"/api/list-with-us",List_form_data).then(res =>{
      SetEmailMessage(res.data.email_message)

      SetVilla('');
      SetName('');
      SetEmail('');
      SetContact('');
      SetLocation('');
      SetMessage('');
      setLoading(false);
      setErrors('');

    }).catch(error => {
      if (error.response && error.response.status === 422) {
        const fieldErrors = error.response.data.errors;
        setErrors({
          villa: fieldErrors.villa?.[0] || '',
          name: fieldErrors.name?.[0] || '',
          email: fieldErrors.email?.[0] || '',
          contact: fieldErrors.contact?.[0] || '',
          location: fieldErrors.location?.[0] || '',
          message: fieldErrors.message?.[0] || '',
          checkbox: fieldErrors.checkbox?.[0] || '',
        });
      }
    }).finally(() => {
      setLoading(false);

    });

  }


  return (
      <div id="list-with-us" className="List_With_Us">
        <div className="container-fluid List_With_Us_from">
          <div className="row">
            <div className="col-md-5">
              <img src={list} alt="List With Us"/>
            </div>
            <div className="col-md-7">
             <div className="right_form_list_with_us">
              <h1>List With us</h1>
              <p>Own a Property? List with Us. Are you a property owner interested in listing your home directly with us? We’d love to hear from you. Please get in touch or fill out the form below, and a member of our team will get back to you shortly.</p>
              <p><b>Own a Property? Let’s Work Together</b></p>
              <p>We are always looking for high quality homes to offer our guests. If you own a property and would like to list it with us directly, we would love to hear from you.</p>
              <p className='you_are_interested'>You are interested in...</p>
              <form onSubmit={List_with_us_form}>
                <div className="row">
                  <div className="col">
                    <select value={villa} onChange={HandleVillaChange}>
                      <option>All Rentals</option>
                      {
                        resorts.map((resort,index) => {
                          return(
                              <option key={index} value={resort.title}>{resort.title}</option>
                              )
                        })
                      }

                    </select>
                    {errors.villa && <span style={{ color: 'red' }}>{errors.villa}</span>}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <input value={name} onChange={HandleNameChange} type="text" className="form-control" placeholder="Full Name" name="name"/>
                    {errors.name && <span style={{ color: 'red' }}>{errors.name}</span>}
                  </div>
                  <div className="col">
                    <input value={email} onChange={HandleEmailChange} type="text" className="form-control" placeholder="Email Address" name="email"/>
                    {errors.email && <span style={{ color: 'red' }}>{errors.email}</span>}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <input value={contact} type="text" onChange={HandleContactChange} className="form-control" placeholder="Contact Number" name="contact"/>
                    {errors.contact && <span style={{ color: 'red' }}>{errors.contact}</span>}
                  </div>
                  <div className="col">
                    <input value={location} type="text" onChange={HandleLocationChange} className="form-control" placeholder="Your Location" name="location"/>
                    {errors.location && <span style={{ color: 'red' }}>{errors.location}</span>}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <textarea value={message} name="message" onChange={HandleMessageChange} rows="5" cols="10" placeholder="Optional Message"></textarea>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" onChange={handleCheckboxChange} id="check1" name="terms_and_conditions" value="something"/>
                      <label className="form-check-label">I agree to the <a href="#">Terms & Conditions.</a></label><br/>
                      {errors.checkbox && <span style={{ color: 'red' }}>{errors.checkbox}</span>}
                    </div>
                  </div>
                  <div className="col">
                    <button
                        type="submit"
                        className="btn  btn-primary w-50 me-2"
                        disabled={loading}
                    >
                      {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                      )  : (
                          "Send"
                      )}
                    </button>
                  </div>
                </div>
              </form>
              <p className={`submition-message ${emailMessage ? "active-message" : ""}`}>
                {emailMessage}
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
};

export default List_With_Us;